import { render } from "./UserTable.vue?vue&type=template&id=b12b2c08&scoped=true&ts=true"
import script from "./UserTable.ts?vue&type=script&lang=ts"
export * from "./UserTable.ts?vue&type=script&lang=ts"

import "./UserTable.scss?vue&type=style&index=0&id=b12b2c08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12b2c08"]])

export default __exports__